export default class SubProduct {
	constructor({ id, name, productId, removed } = {}) {
		this.id = id;
		this.name = name;
		this.productId = productId;
		this.removed = removed;
	}

	static buildFromJSON(json) {
		return new SubProduct({
			id: json.id,
			name: json.name,
			productId: json.product,
			removed: json.removed
		});
	}

	toJSON() {
		return {
			id: this.id,
			name: this.name,
			product: this.productId,
			removed: this.removed
		};
	}

	getId() {
		return this.id;
	}

	getName() {
		return this.name;
	}

	getProductId() {
		return this.productId;
	}

	getRemoved() {
		return this.removed;
	}

	isNotRemoved() {
		return !this.removed;
	}

	isRemoved() {
		return !!this.removed;
	}
}
